import { FC, useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import MainApp from "../app/MainApp";
import AuthApp from "../app/AuthApp";
import NoAuthProforma from "../container/NoAuthProforma";
import SucceedPayment from "../container/SucceedPayment";
import FailedPayment from "../container/FailedPayment";
import RenewByServiceId from "../container/RenewWithoutLogin/RenewByServiceId";
import RenewByLink from "../container/RenewWithoutLogin/RenewByLink";
import RenewProforma from "../container/RenewWithoutLogin/RenewProforma";
import useGlobal from "ui-modules/commons/hooks/use-global";
import usePermission from "ui-modules/commons/hooks/use-permission";

const Routes: FC = () => {
  const tokensMe = useGlobal()?.global.tokensMe || {};
  const { setPermissions } = usePermission();

  useEffect(() => {
    setPermissions(tokensMe.permissions);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokensMe]);

  return (
    <Switch>
      <Route path="/auth">
        <AuthApp />
      </Route>

      <Route exact path="/login">
        <Redirect to="/auth/login" />
      </Route>

      <Route exact path="/proforma-invoice">
        <NoAuthProforma />
      </Route>

      <Route exact path="/succeed-payment">
        <SucceedPayment />
      </Route>

      <Route exact path="/failed-payment">
        <FailedPayment />
      </Route>

      {/* Renew Without Login Routes*/}
      <Route exact path="/services/agreement-items/:id">
        <RenewByServiceId />
      </Route>

      <Route exact path="/services/zitel-service">
        <RenewByLink source="zitel" />
      </Route>

      <Route exact path="/services/renew-link/:id">
        <RenewByLink />
      </Route>

      <Route exact path="/renew-proforma">
        <RenewProforma />
      </Route>

      <Route path="/">
        <MainApp />
      </Route>
    </Switch>
  );
};

export default Routes;
